export const redirectToSearch = ({ locale, searchPath, value }) => {
  window.location.href = `/${locale}${searchPath}?query=${value}`
}
